import {useCallback, useEffect, useRef, useState} from 'react';
import RecommendedComboHeading from './RecommendedComboHeading/RecommendedComboHeading';
import RecommendedComboList from './RecommendedComboList/RecommendedComboList';

const RecommendedCombo = ({handlOpenCalendar = () => {}}) => {
  return (
    <>
      <RecommendedComboHeading />
      <RecommendedComboList handlOpenCalendar={handlOpenCalendar} />
    </>
  );
};
export default RecommendedCombo;
